"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    MeteringACLClient: Symbol("MeteringACLClient"),
    MeteringACLRoute: Symbol("MeteringACLRoute"),
    MeteringBatchClient: Symbol("MeteringBatchClient"),
    MeteringBatchRoute: Symbol("MeteringBatchRoute"),
    MeteringCategoryBatchClient: Symbol("MeteringCategoryBatchClient"),
    MeteringCategoryBatchRoute: Symbol("MeteringCategoryBatchRoute"),
    MeteringCategoryRoute: Symbol("MeteringCategoryRoute"),
    MeteringCategoryClient: Symbol("MeteringCategoryClient"),
    MeteringRoute: Symbol("MeteringRoute"),
    MeteringClient: Symbol("MeteringClient"),
    MeteringSettingsRoute: Symbol("MeteringSettingsRoute"),
    MeteringSettingsClient: Symbol("MeteringSettingsClient"),
    MeteringStatisticsClient: Symbol("MeteringStatisticsClient"),
    MeteringStatisticsRoute: Symbol("MeteringStatisticsRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.MeteringCategoryBatchRoute).to(_1.MeteringCategoryBatchRoute);
    bind(TYPES.MeteringCategoryBatchClient).to(_1.MeteringCategoryBatchClient);
    bind(TYPES.MeteringCategoryRoute).to(_1.MeteringCategoryRoute);
    bind(TYPES.MeteringCategoryClient).to(_1.MeteringCategoryClient);
    bind(TYPES.MeteringBatchRoute).to(_1.MeteringBatchRoute);
    bind(TYPES.MeteringBatchClient).to(_1.MeteringBatchClient);
    bind(TYPES.MeteringStatisticsRoute).to(_1.MeteringStatisticsRoute);
    bind(TYPES.MeteringStatisticsClient).to(_1.MeteringStatisticsClient);
    bind(TYPES.MeteringACLRoute).to(_1.MeteringACLRoute);
    bind(TYPES.MeteringACLClient).to(_1.MeteringACLClient);
    bind(TYPES.MeteringRoute).to(_1.MeteringRoute);
    bind(TYPES.MeteringClient).to(_1.MeteringClient);
    bind(TYPES.MeteringSettingsRoute).to(_1.MeteringSettingsRoute);
    bind(TYPES.MeteringSettingsClient).to(_1.MeteringSettingsClient);
});
exports.diModule = diModule;
